module.exports = __webpack_public_path__ + "static/media/olive.3382b7a3.jpg";